import { render, staticRenderFns } from "./changClause.vue?vue&type=template&id=42a91cf2&scoped=true&"
import script from "./changClause.vue?vue&type=script&lang=js&"
export * from "./changClause.vue?vue&type=script&lang=js&"
import style0 from "./changClause.vue?vue&type=style&index=0&id=42a91cf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a91cf2",
  null
  
)

export default component.exports